import gql from 'graphql-tag';

export const notificationPreference = gql`
  fragment NotificationPreference on NotificationPreference {
    id
    scope
    subjectId
    option
    snoozeUntil
    updatedAt
  }
`;
